import { useCallback } from "react";

import useClient from "hooks/useClient";

export const CancelReasonCode = {
  SCHEDULE_CHANGE: "SCHEDULE_CHANGE",
  PRICE_MISMATCH: "PRICE_MISMATCH",
  FOUND_OTHER_PARKING: "FOUND_OTHER_PARKING",
  OTHER: "OTHER",
} as const;

export type CancelReasonCode = (typeof CancelReasonCode)[keyof typeof CancelReasonCode];

export type CancelRequestPayload = Readonly<{
  cancelReasonCode: CancelReasonCode;
  cancelReasonDetail?: string;
}>;

const useCancelRequestEstimate = (): {
  cancelRequestEstimate: (orderId: string, estimateId: string, payload: CancelRequestPayload) => Promise<number>;
} => {
  const { client } = useClient();

  const cancelRequestEstimate = useCallback(
    async (orderId: string, estimateId: string, payload: CancelRequestPayload) => {
      const { status } = await client({
        method: "post",
        url: `/order/${orderId}/estimate/${estimateId}/cancel-request`,
        data: payload,
      });
      return status;
    },
    [client]
  );

  return { cancelRequestEstimate };
};

export default useCancelRequestEstimate;
